interface LanguageItem {
  label: string;
  id: string;
}

export const getLanguages = (): LanguageItem[] => [
  { label: `Plain text`, id: "plaintext" },
  { label: "C++", id: "cpp" },
  { label: "C#", id: "csharp" },
  { label: "CSS", id: "css" },
  { label: "Go", id: "go" },
  { label: "HTML", id: "html" },
  { label: "Java", id: "java" },
  { label: "JavaScript", id: "javascript" },
  { label: "Objective-C", id: "objective-c" },
  { label: "PHP", id: "php" },
  { label: "Python", id: "python" },
  { label: "Ruby", id: "ruby" },
  { label: "SQL", id: "sql" },
  { label: "Swift", id: "swift" },
  { label: "TypeScript", id: "typescript" },
];
